import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { FaFacebook, FaTwitter } from "react-icons/fa";
import { IoIosLink } from "react-icons/io";
const BlogDetail = () => {
  const buttons = [
    { id: 1, icon: <FaFacebook />, title: "Share" },
    { id: 2, icon: <FaTwitter />, title: "Tweet" },
    { id: 3, icon: <BsLinkedin />, title: "Share" },
    { id: 4, icon: <IoIosLink />, title: "Copy" },
  ];

  const suggestBlogs = [
    {
      id: 1,
      img: "https://images.pexels.com/photos/10928747/pexels-photo-10928747.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      title: "Unlocking the Power of Prompts in UX Design: A Practical Guide",
    },
    {
      id: 2,
      img: "https://images.pexels.com/photos/10928747/pexels-photo-10928747.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      title:
        "Stop Making These Mistakes and You Will Become a Better UX Designer",
    },
    {
      id: 3,
      img: "https://images.pexels.com/photos/10928747/pexels-photo-10928747.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      title: "Top Finance App UI Designs That Will Ignite Your Inspiration",
    },
  ];
  return (
    <>
      <div className="max-w-5xl mx-auto py-10 px-4">
        <div className="text-center md:w-3/4 mx-auto">
          <h1 className="text-[32px]">
            Best Neo brutalism or Neu brutalism UI Design. Get inspired in 2024
          </h1>
          <p className="text-[18px] py-4">
            Neo Brutalism or Neubrutalism has been a hot topic on Dribbble
            lately, and it's easy to see why. If you're daring enough to try
            something totally different, this UI design trend is a great option.
            It won't let you slip away unnoticed; this aesthetic is bold, wild,
            and sure to stand out.
          </p>
        </div>
        <div className="flex  gap-4 items-center justify-center">
          {buttons.map((button) => (
            <div className="border py-2 px-4 rounded-lg flex items-center space-x-2">
              <p>{button.icon}</p>
              <p className="hidden md:block">{button.title}</p>
            </div>
          ))}
        </div>
        <div className="py-6">
          <img
            className="rounded-xl w-full h-[280px] md:w-[960px] md:h-[640px] object-cover"
            src="https://images.pexels.com/photos/10928747/pexels-photo-10928747.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt=""
          />
        </div>
        <div className="py-4 md:w-3/4 mx-auto">
          <p className="">
            Whilst Neumorphism may have had its moment in the spotlight, this UI
            design style is quickly becoming the go-to choice for those who are
            looking to revamp their website or start a new digital product,
            because it is very easy to implement. Take a look at Gumroad, Figma,
            or Code Academy, to make an idea.
          </p>
          <div className="pt-2">
            <h1 className="text-3xl">What is Brutalism?</h1>
            <p className="pt-2">
              The name “Brutalism” originates from the French word “brut,” which
              simply translates to “raw” or “uncultivated”. This architectural
              style was first seen in the middle of the twentieth century and
              became popular in the late 50s and early 60s.
            </p>
            <p className="pt-2">
              It features sharp edges, jagged shapes, rough textures, aged
              surfaces, asymmetrical natural shapes, and metallic hues. The
              materials used in this style of architecture are generally
              concrete, steel, glass, bronze, and iron.
            </p>
            <p className="pt-2">
              I hope this mini tutorial was useful for you guys! Now, we’ve got
              over 10 neo brutalism web design examples that’ll give you a
              supercharge of creative motivation! We will keep this compilation
              refreshed on a monthly basis, so make sure to review it regularly.
              Have fun!
            </p>
            <h1 className="text-3xl pt-2">
              1. Personal Branding by{" "}
              <a href="" className="underline">
                Vladimir Gruev
              </a>
            </h1>
            <p className="py-2">
              Let’s kick off this list with the inspired hero section of
              Vladimir Gruev’s designs. He is a massive admirer of the
              Neobrutalism style and has some great web design pieces. Make sure
              to check out his stunning work!
            </p>
          </div>
        </div>
        <div>
          <img
            className="rounded-xl w-full h-[280px] md:w-[960px] md:h-[640px] object-cover"
            src="https://images.pexels.com/photos/10928747/pexels-photo-10928747.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt=""
          />
        </div>
        <hr className="my-4" />
        <div className="py-4 md:w-3/4 mx-auto">
          <div>
            <h1 className="text-3xl">
              2. Look Beyond Limits by{" "}
              <a href="" className="underline">
                Halo Lab
              </a>
            </h1>
            <p className="py-2">
              The huge typography, prominent separators, and unique angles all
              added up to make this artwork. It’s impossible to not take note of
              the extraordinary Ukrainian design squad at Halo Lab.
            </p>
          </div>
        </div>
        <div>
          <img
            className="rounded-xl w-full h-[280px] md:w-[960px] md:h-[640px] object-cover"
            src="https://images.pexels.com/photos/10928747/pexels-photo-10928747.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt=""
          />
        </div>
        <hr className="my-4" />
        <div className="md:w-3/4 mx-auto">
          <h1 className="text-3xl">3. DRCA</h1>
          <p className="py-2">
            The huge typography, prominent separators, and unique angles all
            added up to make this artwork. It’s impossible to not take note of
            the extraordinary Ukrainian design squad at Halo Lab.
          </p>
        </div>
        <div>
          <img
            className="rounded-xl w-full h-[280px] md:w-[960px] md:h-[640px] object-cover"
            src="https://images.pexels.com/photos/10928747/pexels-photo-10928747.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt=""
          />
        </div>
        <hr className="my-4" />
        <div className="py-4 md:w-3/4 mx-auto">
          <div>
            <h1 className="text-3xl">
              4. Brutal Layout by
              <a href="" className="underline">
                Nanuka Mandaria
              </a>
            </h1>
            <p className="py-2">
              The huge typography, prominent separators, and unique angles all
              added up to make this artwork. It’s impossible to not take note of
              the extraordinary Ukrainian design squad at Halo Lab.
            </p>
          </div>
        </div>
        <div>
          <img
            className="rounded-xl w-full h-[280px] md:w-[960px] md:h-[640px] object-cover"
            src="https://images.pexels.com/photos/10928747/pexels-photo-10928747.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt=""
          />
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 pb-14 h-full">
        <h1 className="text-3xl">Read Next</h1>
        <div className="flex space-x-6 overflow-x-auto hidescroll items-center py-4">
          {suggestBlogs.map((suggestBlog, index) => (
            <div key={index} className="w-[364px] rounded-xl flex-shrink-0">
              <img
                className="w-full h-[265px] rounded-xl object-cover"
                src={suggestBlog.img}
                alt=""
              />
              <p className="py-2 text-xl ">{suggestBlog.title}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
